"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./MarketingVideo.css");

var _react = _interopRequireDefault(require("react"));

var _gaEventTracker = _interopRequireDefault(require("../../../util/gaEventTracker"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _LoadSpinner = require("../message/LoadSpinner");

var _Modal = _interopRequireDefault(require("../../../components/common/Modal"));

var _Propulator = _interopRequireDefault(require("../../../higher-order/Propulator"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _class, _class2, _descriptor;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var MarketingVideo = (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(MarketingVideo, _React$Component);

  var _super = _createSuper(MarketingVideo);

  function MarketingVideo() {
    var _this;

    _classCallCheck(this, MarketingVideo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _initializerDefineProperty(_assertThisInitialized(_this), "isLoaded", _descriptor, _assertThisInitialized(_this));

    return _this;
  }

  _createClass(MarketingVideo, [{
    key: "handleVideoClick",
    value: function handleVideoClick(e) {
      this.props.dispatcher.emit("OPEN_MODAL", {
        modalKey: this.props.videoModal.modalKey
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Log vimeo events to google analytics.
      var iframe = this.iframe;
      window.addEventListener("message", function (e) {
        if (e.origin !== "https://player.vimeo.com" || !(0, _isString.default)(e.data)) {
          return;
        }

        var data = JSON.parse(e.data);

        switch (data.event) {
          case "ready":
            _this2.isLoaded = true;

            if (iframe && iframe.contentWindow) {
              var request = {
                method: "addEventListener",
                value: "play"
              };
              iframe.contentWindow.postMessage(JSON.stringify(request), "https://player.vimeo.com");
            }

            break;

          case "play":
            (0, _gaEventTracker.default)("video", "play", _this2.props.gaName);
            break;

          default:
            break;
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.props.renderButton && this.props.renderButton(this.handleVideoClick), !this.props.renderButton && /*#__PURE__*/_react.default.createElement("button", {
        className: "marketing-video-open-button",
        onClick: this.handleVideoClick
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "button-preview",
        src: this.props.previewSrc,
        alt: "Play video"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "overlay"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "play-video"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "desktop"
      }, "Play Video"), /*#__PURE__*/_react.default.createElement("i", {
        className: "icon-play-circled"
      }))), /*#__PURE__*/_react.default.createElement(_Modal.default, _extends({}, this.props.videoModal, {
        className: "marketing-video-modal"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "marketing-video-container",
        key: this.props.src
      }, /*#__PURE__*/_react.default.createElement("iframe", {
        title: "Gradifi is Gratitude",
        ref: function ref(iframe) {
          _this3.iframe = iframe;
        },
        className: "marketing-video",
        src: this.props.src,
        width: "640",
        height: "360",
        frameBorder: "0",
        allowFullScreen: true
      }), !this.isLoaded && /*#__PURE__*/_react.default.createElement(_LoadSpinner.LoadingSpinner, null))));
    }
  }]);

  return MarketingVideo;
}(_react.default.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "isLoaded", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "handleVideoClick", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleVideoClick"), _class2.prototype)), _class2)) || _class;

var _default = (0, _Propulator.default)(MarketingVideo, {});

exports.default = _default;